import { jwtDecode } from "jwt-decode";
import { UserRole } from "../services/queries/users/types";
import { logError } from "./sentry";

export function getUserRole(role: UserRole) {
  return {
    isAdmin: role === UserRole.ADMIN,
    isStaff: role === UserRole.STAFF,
  };
}

export const getUserRoleFromToken = (token: string): UserRole | undefined => {
  try {
    const decoded: { role?: UserRole } = jwtDecode(token);
    return decoded.role;
  } catch (error) {
    logError(error);
    return;
  }
};
